import { reactive } from 'vue'

export const notifier = reactive({
    show: false,
    text: '',
    color: 'info',
    timeout: 3000
})

export function notifySuccess(message) {
    notifier.text = message
    notifier.color = 'success'
    notifier.show = true
}

export function notifyError(message) {
    notifier.text = message
    notifier.color = 'error'
    notifier.show = true
}


